export default function getParsedTokenTitle(keycloak) {
  if (!keycloak || !keycloak.tokenParsed) {
    return '';
  }

  const { jobTitle, title } = keycloak.tokenParsed;
  return jobTitle || title || '';
}



// WEBPACK FOOTER //
// ./src/utils/keycloak.js